<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Block Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <form data-vv-scope="filterForm">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-sm>
                        <v-layout row wrap>
                          <v-flex lg6 xs12>
                            <v-text-field
                              data-vv-scope="filterForm"
                              v-model="filters.blk"
                              :label="labels.blk"
                              :error-messages="errors.collect('filtersBlk')"
                              data-vv-name="filtersBlk"
                              :data-vv-as="labels.blk"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions right>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                      <v-btn color="primary" text @click.prevent="doFilters">Apply Filters</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-data-table
                :headers="headers"
                :items="items"
                v-bind:options.sync="pagination"
                :footer-props="{ 'items-per-page-options': itemsPerPage }"
                :server-items-length="totalItems"
                :loading="loading"
                class="elevation-1"
                :no-data-text="noDataText"
                item-key="key"
                v-model="selected"
                show-select
                @input="enterSelect"
                @toggle-select-all="enterSelectAll(pagination, items, selected)"
              >
              </v-data-table>
              <div v-if="checkedItems.length === 0" class="small font-weight-light grey--text">Note: Default is "None" if no item is selected.</div>
              <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" dark class="mr-2" @click="doSelectExclude('None', 'blk')">
                Select None
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="info" dark class="mr-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn
              >
              <v-btn color="primary" dark class="mr-2" @click="doSelectExclude('', 'blk')">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { expandURI, filterQuery } from '@/utils/ajax'
import { helpListMixin } from '@/mixins/common/helpListMixin'

export default {
  data() {
    return {
      headers: [
        { text: 'Block', value: 'blk' },
        { text: 'Block Descripton', value: 'blkDesc' }
      ],
      selected: [],
      totalItems: 0,
      labels: {
        blk: 'Block'
      },
      filters: {
        blk: null
      },
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.blkParam.menu
    }
  },
  mounted() {
    if (this.$store.state.blkParam.init !== 1) {
      this.$store.dispatch('blkParamManagementInit')
    }
    this.doClearFilters()
  },
  methods: {
    closeDialog() {
      this.filters.blk = ''
      this.$emit('close')
    },
    doClearFilters() {
      this.filters.blk = null
      this.fetchData()
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('filterForm').then((result) => {
        if (result) {
          this.pagination.page = 1
          this.fetchData()
        }
      })
    },
    async fetchData() {
      const apiUrl = this.menu.getBlkList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          let massageFilters = {
            accmType: this.accmType,
            blkGrpFrm: this.blkGrpFrm,
            blkGrpTo: this.blkGrpTo,
            blksGrp1Frm: this.blksGrp1Frm,
            blksGrp1To: this.blksGrp1To,
            blksGrp2Frm: this.blksGrp2Frm,
            blksGrp2To: this.blksGrp2To,
            blkSW: this.filters.blk
          }
          this.$http
            .get(filterQuery(expandURI(apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc))
            .then((result) => {
              this.totalItems = result.data.totalElements
              this.items = []
              this.selectedItems = []
              if (result.data) {
                const { data } = result.data
                data.map((param) => {
                  const convertList = {
                    key: param.blk,
                    blk: param.blk,
                    blkDesc: param.blkDesc
                  }
                  if (this.checkedItems.includes(param.blk)) {
                    const _blk = {
                      key: param.blk,
                      blk: param.blk,
                      blkDesc: param.blkDesc
                    }
                    this.selectedItems.push(_blk)
                  }
                  this.items.push(convertList)
                })
              }
              if (this.checkedItems.toString() === 'All') {
                this.doReset()
                this.toggleAll()
              } else {
                this.toggleSelected()
              }
              this.loading = false
            })
            .catch((err) => {
              this.loading = false
              const { data } = err.response
              if (data) {
                this.message(data)
                this.fieldMessage(data)
              }
            })
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  watch: {
    pagination: function (value) {
      this.fetchData()
    }
  },
  props: {
    accmType: {
      type: String,
      default: undefined
    },
    blkGrpFrm: {
      type: String,
      default: undefined
    },
    blkGrpTo: {
      type: String,
      default: undefined
    },
    blksGrp1Frm: {
      type: String,
      default: undefined
    },
    blksGrp1To: {
      type: String,
      default: undefined
    },
    blksGrp2Frm: {
      type: String,
      default: undefined
    },
    blksGrp2To: {
      type: String,
      default: undefined
    },
    excBlk: {
      type: String,
      default: undefined
    }
  },
  mixins: [TableConst.default, commonAjaxMixin, helpListMixin]
}
</script>
